// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ArrowSmallUpRightIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon
      data-iconname="ArrowSmallUpRightIcon"
      ref={forwardedRef}
      {...props}
    >
      <path d="M7 7h6v6h-1.5V8.5H7z" />
      <path d="m12.5 8.5-4.243 4.243-1.06-1.061 4.242-4.243z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ArrowSmallUpRightIcon = /* @__PURE__ */ Object.assign(
  ArrowSmallUpRightIconComponent,
  { displayName: 'ArrowSmallUpRightIcon' },
);
